export const SSD = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_10969)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <g clipPath="url(#clip0_2954_10969)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.1667 66.3608H29.8333C28.8235 66.3608 28 65.5372 28 64.5275V35.4727C28 34.4629 28.8235 33.6394 29.8333 33.6394H70.1666C71.1764 33.6394 71.9999 34.4629 71.9999 35.4727V64.5274C72 65.5372 71.1765 66.3608 70.1667 66.3608ZM57.6027 56.3672H61.3218C64.1805 56.3672 66.5028 54.0418 66.5028 51.1829V48.8178C66.5028 45.9587 64.1805 43.633 61.3218 43.633H57.6027C56.794 43.633 56.1366 44.2895 56.1366 45.0994V54.9008C56.1366 55.7112 56.794 56.3672 57.6027 56.3672ZM59.0687 46.5664V53.4338H61.3218C62.563 53.4338 63.5706 52.4236 63.5706 51.1829V48.8178C63.5706 47.5766 62.563 46.5664 61.3218 46.5664H59.0687ZM33.4929 47.5502C33.4929 49.7095 35.2487 51.467 37.4109 51.467H39.9451C40.4771 51.467 40.9269 51.9168 40.9269 52.4503C40.9269 52.984 40.4771 53.4337 39.9451 53.4337H37.411C37.091 53.4337 36.7926 53.2754 36.6023 53.0104C36.1397 52.3488 35.2228 52.1892 34.5612 52.6557C33.8995 53.1224 33.7395 54.037 34.2065 54.6987C34.9417 55.744 36.1397 56.3672 37.411 56.3672H39.9452C42.1032 56.3672 43.859 54.6101 43.859 52.4504C43.859 50.2907 42.1032 48.5337 39.9452 48.5337H37.411C36.8748 48.5337 36.425 48.0834 36.425 47.5503C36.425 47.0166 36.8748 46.5665 37.411 46.5665H39.9452C40.3085 46.5665 40.6458 46.771 40.8189 47.101C41.1951 47.8189 42.0816 48.0952 42.7953 47.7185C43.5132 47.3427 43.7899 46.4566 43.4137 45.7396C42.7347 44.4409 41.4026 43.6331 39.9453 43.6331H37.411C35.2487 43.633 33.4929 45.3901 33.4929 47.5502ZM44.8148 47.5502C44.8148 49.7095 46.5706 51.467 48.7329 51.467H51.2671C51.799 51.467 52.2488 51.9168 52.2488 52.4503C52.2488 52.984 51.799 53.4337 51.2671 53.4337H48.7329C48.4128 53.4337 48.1144 53.2754 47.9241 53.0104C47.457 52.3478 46.5445 52.1892 45.8829 52.6557C45.2213 53.1224 45.0613 54.037 45.5282 54.6987C46.2634 55.744 47.4614 56.3672 48.7329 56.3672H51.2671C53.425 56.3672 55.1808 54.6101 55.1808 52.4504C55.1808 50.2907 53.425 48.5337 51.2671 48.5337H48.7329C48.1966 48.5337 47.7468 48.0834 47.7468 47.5503C47.7468 47.0166 48.1966 46.5665 48.7329 46.5665H51.2671C51.6303 46.5665 51.9676 46.771 52.1407 47.101C52.5169 47.8189 53.4035 48.0952 54.1214 47.7185C54.8349 47.3427 55.1117 46.4566 54.7355 45.7396C54.0565 44.4409 52.7245 43.6331 51.2671 43.6331H48.7329C46.5706 43.633 44.8148 45.3901 44.8148 47.5502ZM30.9327 38.2228C30.9327 39.1323 31.6722 39.8731 32.5804 39.8731C33.4929 39.8731 34.2324 39.1323 34.2324 38.2228C34.2324 37.3146 33.4929 36.573 32.5804 36.573C31.6722 36.573 30.9327 37.3147 30.9327 38.2228ZM65.7633 38.2228C65.7633 39.1323 66.5071 39.8731 67.4153 39.8731C68.3235 39.8731 69.063 39.1323 69.063 38.2228C69.063 37.3146 68.3235 36.573 67.4153 36.573C66.5071 36.573 65.7633 37.3147 65.7633 38.2228ZM69.063 61.7773C69.063 60.8683 68.3235 60.1275 67.4153 60.1275C66.5071 60.1275 65.7633 60.8683 65.7633 61.7773C65.7633 62.6859 66.5071 63.4276 67.4153 63.4276C68.3235 63.4277 69.063 62.6859 69.063 61.7773ZM30.9327 61.7773C30.9327 62.6859 31.6722 63.4276 32.5804 63.4276C33.4929 63.4276 34.2324 62.6859 34.2324 61.7773C34.2324 60.8683 33.4929 60.1275 32.5804 60.1275C31.6722 60.1275 30.9327 60.8684 30.9327 61.7773Z"
          fill="#262626"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2954_10969"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_10969"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_10969"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2954_10969">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(28 28)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
